import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

export interface Props {}

const RestDayDisplay = ({}: Props) => {
  return (
    <Box
      justifyContent="spaceBetween"
      borderRadius={{
        all: 'abs008',
      }}
      padding="s16"
      width="full"
      background="grey100"
      gap="s8"
    >
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" width="full">
        <Text.Normal weight="medium">
          {i18n.t('shift_management.templates.weeks.settings_rest_day_2.title')}
        </Text.Normal>
      </Box>

      <Text.Normal>
        {i18n.t('shift_management.templates.weeks.settings_rest_day_2.description')}
      </Text.Normal>
    </Box>
  )
}

export default observer(RestDayDisplay)
